import { css } from '@inter-ikea-kompis/web-component';
import type { ITheme } from '@inter-ikea-kompis/types';

import { Text } from '@ingka/common-styles-webc';

export default class ProductListStyle {
	/**
	 * Returns styles.
	 *
	 * @param options Options object.
	 * @param options.theme Theme.
	 * @param options.isCompactLayout Stuff.
	 * @returns Styles.
	 */
	public static getStyle(options: { theme: ITheme; isCompactLayout: boolean }): string {
		const { spacing, color, border } = options.theme;
		return css`
			${Text.CSS}
			:host {
				display: block;
			}

			kompis-product-row {
				flex-shrink: 0;
				margin: ${options.isCompactLayout ? spacing.space50 / 16 : spacing.space150 / 16}rem 0;
			}

			.row-wrapper {
				border-bottom: ${1 / 16}rem solid ${color.neutral.grey200};
			}

			.container {
				position: relative;
			}

			.skipButton:not(:focus) {
				clip: rect(0.06rem, 0.06rem, 0.06rem, 0.06rem);
				overflow: hidden;
				padding: 0;
			}

			.skipButton {
				position: absolute;
				z-index: 1;
				top: ${spacing.space150 / 16}rem;
				left: ${spacing.space150 / 16}rem;
			}

			kompis-product-list-section {
				display: block;
			}

			ul,
			li {
				list-style: none;
				margin: 0;
				padding: 0;
			}

			kompis-product-list-section:not(:first-of-type) {
				padding-top: ${spacing.space200 / 16}rem;
			}

			.compactListHeaders {
				display: grid;
				/* This style is the same as in compact product row, to make the grid match the product row columns. */
				grid-template-columns: ${30 / 16}rem 1fr ${83 / 16}rem ${86 / 16}rem ${60 / 16}rem ${80 /
					16}rem ${80 / 16}rem;
				gap: 0 ${spacing.space75 / 16}rem;
				color: ${color.text.default};
				border-bottom: ${border.thickness.thin / 16}rem solid ${color.border.light};
				padding-bottom: ${spacing.space50 / 16}rem;
				align-items: flex-start;
			}

			.compactListHeaders h4 {
				font-weight: normal;
				overflow-wrap: break-word;
				hyphens: auto;
				margin: 0;
			}

			.compactListHeaders h4,
			.compactListHeaders span {
				font-size: ${10 / 16}rem !important;
			}

			.location {
				display: flex;
				justify-content: space-between;
			}

			.location span {
				word-break: break-all;
			}
			.divider {
				width: ${spacing.space25 / 16}rem;
			}

			.compactListHeaders h4:last-child {
				text-align: end;
			}
		`;
	}
}
